import React from 'react';
import { Link } from 'react-router-dom';

const WordleHypePage = () => {
  return (
    <div>
      {/* Article Header */}
      <section
        className="h-[42vh] sm:h-[49vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: "url('/images/LJM-Blog-Images-1.webp')"
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        />

        {/* Banner Content */}
        <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
          <div className="text-center text-white max-w-6xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-4 sm:mb-6 leading-tight text-white">
              The Rise of Wordle: What is it and how are brands joining the hype?
            </h1>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-8 sm:py-10 md:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="blog_inner">
            <div className="blog_lift_sidebar">
              <div className="blog_items">
                <div className="prose prose-lg max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    An online word game developed by Josh Wardle. Players attempt to guess a five-letter word, if incorrect the feedback given for each guess will help you progress, as the colored tiles indicate when letters match or are wrong. You can try it online <a href="https://www.nytimes.com/games/wordle/index.html" target="_blank" rel="noreferrer noopener" className="text-pink-600 hover:text-pink-700 underline">here.</a> The game has become a part of popular culture and a fixture in social media news feeds for weeks since it's invention at the end of 2021.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    Wordle in social media marketing
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    In social media marketing having the right conversations is everything. When topics are trending, being part of the hype could bring you an abundance of brand awareness. Wordle is perfect for this because everyone is playing and talking about it on their platforms, users are even actively seeking out Wordle-based posts from big brands and sharing them.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Twitter has been the go to for this with hundreds of thousands of people tweeting their results every single day, it makes for a powerful moment on social media. Social media ads can also be implemented in your social media strategy to create a buzz around your brand. <Link to="/evidence" className="text-pink-600 hover:text-pink-700 underline" onClick={() => window.scrollTo(0, 0)}>Click here</Link> to find out how we have helped brands in the past implement ads into their data marketing plans.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    How can your business jump on the Wordle hype?
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Marketing using the Wordle hype is accessible for even the smallest companies, as content marketing is a relatively low cost form of marketing or in-depth research to get correct. Just a familiar theme worded in a different way can be enough to make it big. And it can be implemented into your strategy to mix things up a bit rather than more business/sales focused posts on social media.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Wordle has become a creative, buzzy social media marketing tactic to get on board with this year, businesses are uncovering new and clever ways to put their own spin on it and Wordle results that are posted to social media can be rewarded with likes, shares and follows which again is great for brand awareness. This will have a positive effect on your future published content and therefore get more people clicking through to your web pages. And what business doesn't want people clicking through to their website so that they can later sell to them.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WordleHypePage;